import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Seo from "@/components/site/Seo";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Features from "@/pages/Features";
import Packages from "@/pages/Packages";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BecomePartner from "@/pages/BecomePartner";
import Disclaimer from "@/pages/Disclaimer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import Terms from "@/pages/Terms";
import AccountDeactivation from "@/pages/AccountDeactivation";
import MerchantOnboardingPolicy from "@/pages/MerchantOnboardingPolicy";
import MerchantSettlementPolicy from "@/pages/MerchantSettlementPolicy";
import ReferralRedirect from "@/pages/ReferralRedirect";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Seo />
        <Routes>
          <Route path="/ref/:code" element={<ReferralRedirect />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/features" element={<Features />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/become-partner" element={<BecomePartner />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/account-deactivation" element={<AccountDeactivation />} />
            <Route path="/merchant-onboarding-policy" element={<MerchantOnboardingPolicy />} />
            <Route path="/merchant-settlement-policy" element={<MerchantSettlementPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
